import * as React from 'react';

export interface ScrollspyContextValues {
    activeValue: string | null;
    navigationRef: ((element: HTMLElement) => void) | null;
    isNavigationStuck: boolean;
    onButtonClick: ((value: string) => void) | null;
    onNavigationStuckChange: ((stuck: boolean) => void) | null;
    registerTarget: ((element: HTMLElement) => void) | null;
    deregisterTarget: ((element: HTMLElement) => void) | null;
}

export const ScrollspyContext = React.createContext<ScrollspyContextValues>({
    activeValue: null,
    navigationRef: null,
    isNavigationStuck: false,
    onButtonClick: null,
    onNavigationStuckChange: null,
    registerTarget: null,
    deregisterTarget: null,
});

export function useScrollspyContext(): ScrollspyContextValues {
    return React.useContext(ScrollspyContext);
}
